import styled from 'styled-components';

const StyledNavigation = styled.nav `
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 3.75rem;
  min-height: 4.375rem;
  width: 100%;
  max-width: ${props => props.theme.breakpoints.max};
  box-shadow: 0px -1px 10px 0px ${props => props.theme.colors.black}26;

  @media screen and (max-width: ${props => props.theme.breakpoints.xl}) {
    justify-content: center;
  }
`;

export { StyledNavigation };
//# sourceMappingURL=SimpleNavigation.styles.mjs.map
